import React, { useState } from 'react';
import './productFilter.css';

const ProductFilter = ({ categories, activeCategory, setActiveCategory, setSearchTerm,searchTerm }) => {

  // Manejar el cambio en el campo de búsqueda
  

  return (
    <div className="filter-container">
      {/* Filtro de categorías */}
      <div className="nav-tabs">
        {categories.map((category) => (
          <a
            key={category}
            className={`tab ${activeCategory === category ? 'active' : ''}`}
            onClick={() => setActiveCategory(category)}
          >
            {category.charAt(0).toUpperCase() + category.slice(1)}
          </a>
        ))}
      </div>

      {/* Barra de búsqueda */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Buscar por nombre..."         
          onChange={setSearchTerm}
        />
      </div>
    </div>
  );
};

export default ProductFilter;
